"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowedNodeTypes = void 0;
var allowedNodeTypes = exports.allowedNodeTypes = ['p', 'a', 'br', 'strong'];